<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      width="80vw"
      :visible="visible"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-share-modal"
    >
      <div class="c-share">
        <div class="title">
          {{ $t("share.title") }}
        </div>
        <div v-if="isCN" class="icons">
          <div class="icon" @click="onShare('weibo')">
            <i class="share iconfont iconweibo" />
          </div>
          <div class="icon" @click="onShare('qzone')">
            <i class="share iconfont iconqzone" />
          </div>
          <div class="icon" @click="onShare('qq')">
            <i class="share iconfont iconqq" />
          </div>
          <div class="icon" @click="onShare('weixin')">
            <i class="share iconfont iconweixin" />
          </div>
          <div class="icon" @click="onShare('bilibili')">
            <i class="share iconfont iconbilibili" />
          </div>
        </div>
        <div v-else class="icons">
          <div class="icon" @click="onShare('twitter')">
            <i class="share iconfont icontwitter" />
          </div>
          <div class="icon" @click="onShare('facebook')">
            <i class="share iconfont iconFB" />
          </div>
          <div class="icon" @click="onShare('pinterest')">
            <i class="share iconfont iconpinterest" />
          </div>
        </div>
        <div class="tips">
          {{ $t("share.or") }}
        </div>
        <div class="copy">
          <input id="url" :value="url" />
          <button
            class="md-button"
            id="clipboard"
            ref="clipboard"
            data-clipboard-target="#url"
          >
            {{ $t("share.copy") }}
          </button>
        </div>
        <i class="close iconfont iconclose-o" @click="visible = false" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
import { mapState } from "vuex";
export default {
  name: "CShare",
  data() {
    return {
      visible: false,
      clipboard: null,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    url() {
      return window.location.origin + this.$route.fullPath;
    },
  },
  methods: {
    onShare(channel) {
      const url = encodeURIComponent(this.url);
      const title = encodeURIComponent("Angry Miao");
      const desc = encodeURIComponent("Future Art Community");
      const image = encodeURIComponent("https://www.angrymiao.com/logo.png");
      switch (channel) {
        case "weibo":
          window.open(
            `https://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=`,
            "_blank"
          );
          break;
        case "qzone":
          window.open(
            `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&site=${title}&title=${title}&desc=${desc}&summary=${desc}&pics=${image}`,
            "_blank"
          );
          break;
        case "qq":
          window.open(
            `https://connect.qq.com/widget/shareqq/index.html?url=${url}&site=${title}&title=${title}&desc=${desc}&summary=${desc}&pics=${image}`,
            "_blank"
          );
          break;
        case "weixin":
          this.$refs.clipboard.click();
          break;
        case "bilibili":
          this.$refs.clipboard.click();
          break;
        case "twitter":
          window.open(
            `https://twitter.com/intent/tweet?text=${title}&url=${url}`,
            "_blank"
          );
          break;
        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?href=${url}`,
            "_blank"
          );
          break;
        case "pinterest":
          window.open(
            `https://www.pinterest.com/pin/create/button/?url=${url}`,
            "_blank"
          );
          break;
      }
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        setTimeout(() => {
          this.clipboard = new ClipboardJS("#clipboard");
          this.clipboard.on("success", () => {
            this.$message.info(this.$t("share.copied"));
          });
        }, 200);
      } else if (this.clipboard) {
        this.clipboard.destroy();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.c-share {
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #ffffff;
    line-height: 70px;
    margin-bottom: 80px;
  }

  .tips {
    width: 440px;
    font-size: 20px;
    color: #ffffff;
    line-height: 18px;
    text-align: left;
    margin: 60px auto 0 auto;
  }

  .icons {
    @include flex-center;

    .icon {
      @include flex-center;
      width: 75px;
      height: 75px;
      background: #333333;
      border-radius: 50%;
      color: #ffffff;
      margin: 0 20px;
      cursor: pointer;

      &:hover {
        background: $primary-color;
      }

      i {
        font-size: 32px;

        &.icondiscord {
          font-size: 40px;
        }
      }
    }
  }

  .copy {
    @include flex-center;
    width: 440px;
    margin: 10px auto 0 auto;

    input {
      width: 360px;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      font-size: 20px;
      color: #ffffff;
      border: 1px solid $primary-color;
      border-right: 0;
      border-radius: 10px 0px 0px 10px;
    }

    button {
      width: 80px;
      height: 50px;
      line-height: 50px;
      background: $primary-color;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      margin: 0;
      border-radius: 0px 10px 10px 0px;
    }
  }

  .close {
    @include icon-hover;
    font-size: 40px;
    position: absolute;
    bottom: -100px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
